<template>
  <div>
    <h2>Children</h2>
    <p>
      Legally, your children include all your biological children and children
      legally adopted by you.
    </p>
    <ul>
      <li>Please list all your children here</li>
      <li>
        Should you neglect to list a child here, you may unintentionally exclude
        them from your will
      </li>
    </ul>
    <PeopleList
      :people="relations.children"
      :testator="testator"
      relation="CHILD"
      :display-existing-people="false"
    />

    <div class="button-container">
      <DefaultButton
        @defaultButtonClicked="redirectBack"
        :small="true"
        :callout="'left'"
      />
      <GradientButton
        v-if="displayNextButton"
        @gradientButtonClicked="redirectToNext"
        :title="'Next'"
        :callout="'right'"
        :small="true"
      />
    </div>
  </div>
</template>

<script>
  import PeopleList from './PeopleList.vue';

  export default {
    name: 'AddChildren',
    components: {
      PeopleList,
    },
    props: {
      testator: { type: Object, required: true },
      relations: { type: Object, required: true },
    },
    computed: {
      displayNextButton() {
        return this.relations.children.length > 0;
      },
    },
    methods: {
      redirectToNext() {
        this.$router.push('guardian');
      },
      redirectBack() {
        this.$router.push('children');
      },
    },
  };
</script>

<style lang="scss" scoped>
  .button-container {
    margin-top: 40px;
    display: flex;
    gap: 20px;
  }
</style>
